<template>
  <v-dialog v-model="dialogApprover" persistent max-width="506px" width="506px" :retain-focus="false">
    <v-card tile class="pt-4 pl-10 pr-10 pb-4 card-outter" height="520">
      <div class="">
        <span class="black--text font-weight-bold mr-5">เพิ่มผู้อนุมัติ</span>
        <v-btn absolute right top icon x-small @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider class="mt-1 mb-4"/>
      <v-row class="mb-0 mt-2" align="center" style="margin-top: -10px;">
        <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: -5px;">
          <span>เลือกผู้อนุมัติ</span>
          <v-autocomplete
            v-model="dataSearchEmployee"
            class="mt-1"
            :items="itemUser"
            item-text="employeeId"
            item-value="employeeId"
            :loading="isLoading"
            hide-details
            hide-selected
            return-object
            placeholder="ค้นหา พนักงาน"
            dense
            outlined
            @change="setImg()"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  ค้นหาพนักงานโดย
                  <strong>รหัสพนักงาน</strong>
                </v-list-item-title>
              </v-list-item>
            </template>
            <template
                slot="selection"
                slot-scope="{ item }"
              >
              {{item.employeeId}} - {{item.name}}
              </template>
            <template v-slot:item="{ item }">
              {{item.employeeId}} - {{item.name}}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mb-0 mt-2" align="center" style="margin-top: -10px;">
        <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: -5px;" v-if="dataSearchEmployee">
          <span>ผลการค้นหา</span>
        </v-col>
        <v-col cols="12" v-if="dataSearchEmployee">
            <v-card
              class="user-data-panel"
              style="margin-top: -14px;"
              outlined
            >
            <v-row class="pl-1 pr-1 pt-0">
                <v-col cols="12" sm="3" md="3" lg="4" class="">
                  <v-avatar
                    class="ml-3 mt-1"
                    :size="$vuetify.breakpoint.name !== 'lg'? '90':'90'"
                    rounded
                  >
                  <v-img
                    cover
                    :lazy-src="require('@/assets/icons/no_user.png')"
                    :src="dataSearchEmployee.userImg? dataSearchEmployee.userImg : require('@/assets/icons/no_user.png')"
                  >
                  </v-img>
                  </v-avatar>
                </v-col>
                <v-col  style="margin-top: -10px; margin-bottom: -10px;">
                  <v-row>
                    <v-col cols="12" class="text-left">
                      <span class="ra-head-text-gray">ชื่อ - นามสกุล</span><br>
                      <span class="ra-head-text black--text">{{ dataSearchEmployee.name || '-' }}</span>
                    </v-col>
                    <v-col cols="12" class="text-left">
                      <span class="ra-head-text-gray">อีเมล</span><br>
                      <span class="ra-head-text black--text">{{ dataSearchEmployee.email || '-' }}</span>
                    </v-col>
                    <v-col cols="12" class="text-left">
                      <span class="ra-head-text-gray">ตำแหน่ง</span><br>
                      <span class="ra-head-text black--text">{{ dataSearchEmployee.position.positionName || '-' }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <FullLoading :loading="loadingUsers"></FullLoading>
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class=""  outlined color="primary" dark @click="closeDialog">ยกเลิก</v-btn>
        <v-btn class="create-orgchart-header-cancel-btn pa-3" color="success" @click="confirmApprover()">บันทึก</v-btn>
      </v-card-actions> -->
      <v-card-actions class="justify-center pb-0 " style="position: absolute; bottom: 20px; left: 110px;">
        <v-btn
          color="primary"
          outlined
          class="head-search-button mr-4"
          width="100"
          @click="closeDialog()"
        >
        ยกเลิก
        </v-btn>
        <v-btn
          color="primary"
          class="head-search-button ml-4 white--text text--lighten-4"
          elevation="0"
          width="140"
          :disabled="!dataSearchEmployee"
          @click="confirmApprover()"
          bottom
          v-if="action=='add'"
        >
        เพิ่มผู้อนุมัติ
        </v-btn>
        <v-btn
          color="primary"
          class="head-search-button ml-4 white--text text--lighten-4"
          elevation="0"
          width="140"
          :disabled="!dataSearchEmployee || dataSearchEmployee.userId == focusUserid"
          @click="confirmChangeApprover()"
          bottom
          v-if="action=='edit'"
        >
        ยืนยันการแก้ไข
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FullLoading } from '@/components/index'
import { getUserByKeyword, hostImageUrlv3 } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  name: 'dialog-create-approver',
  components: {
    FullLoading
  },
  data () {
    return {
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogApprover: false,
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      email: '',
      img: '',
      employeeId: '',
      id: '',
      position: '',
      dataSearchEmployee: '',
      action: '',
      index: '',
      items: [],
      itemUser: [],
      itemUserBackup: [],
      search: null,
      select: null,
      searchEmpoyee: null,
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ],
      focusUserid: '',
      focusApproverIndex: '',
      alreadyUser: []
    }
  },
  mounted () {
    EventBus.$on('openDialogAddAprover', this.openDialogAddAprover)
  },
  watch: {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.getUser()
  },
  methods: {
    setImg () {
      if (this.dataSearchEmployee) {
        this.dataSearchEmployee.userImg = `${hostImageUrlv3}/_/${this.dataSearchEmployee.emailOneId || this.dataSearchEmployee.email}`
      }
    },
    async openDialogAddAprover (value, item, action, index, alreadyUser) {
      this.action = action
      this.index = index
      this.dataSearchEmployee = item.employeeId
      this.dialogApprover = value
      this.alreadyUser = alreadyUser
      this.itemUser = await this.limiterUser()
      if (this.action === 'edit') {
        // this.searchEmployee(this.dataSearchEmployee)
        // console.log('index', index)
        this.focusUserid = item.userId
        this.focusApproverIndex = index
        var forcusItems = {
          approverId: item.approverId,
          name: item.approverName,
          approverNo: item.approverNo,
          email: item.email,
          employeeId: item.employeeId,
          position: { positionName: item.position },
          userId: item.userId,
          userImg: item.userImg
        }
        this.dataSearchEmployee = forcusItems
      } else if (this.action === 'add') {
        // console.log('add')
      }
    },
    closeDialog () {
      this.clearSearchEmployee()
      this.dialogApprover = false
    },
    clearSearchEmployee () {
      this.loadingUsers = true
      this.dataSearchEmployee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.email = ''
      this.img = ''
      this.id = ''
      this.loadingUsers = false
    },
    async getUser () {
      this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          temp = res.result
          this.itemUserBackup = JSON.parse(JSON.stringify(temp))
          this.itemUser = await this.limiterUser()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async limiterUser () {
      var result = this.itemUserBackup.filter(e => {
        return !this.alreadyUser.includes(e.userId)
      })
      return result
    },
    async searchEmployee (value) {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        search: value
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.result[0]) {
          this.id = res.result[0].id
          this.fNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.email = res.result[0].email
          this.img = res.result[0].userImg
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    confirmApprover () {
      if (this.dataSearchEmployee === '') {
        swal('คำเตือน', 'กรุณากรอกรหัสพนักงานที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        this.$emit('pressAddApprover', this.dataSearchEmployee)
        this.dialogApprover = false
        this.dataSearchEmployee = ''
        // swal('Success', 'โอนย้ายสิทธิ์ สำเร็จ', 'success')
      }
    },
    confirmChangeApprover () {
      if (this.dataSearchEmployee === '') {
        swal('คำเตือน', 'กรุณากรอกรหัสพนักงานที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        this.$emit('pressChangeApprover', { approver: this.dataSearchEmployee, index: this.focusApproverIndex })
        this.dialogApprover = false
        this.dataSearchEmployee = ''
      }
    }
  }
}
</script>
<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 20px;
  left: 120px;
}
@import '../../../css/ManageEmployee.css';
</style>
